/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListActivities200ResponseMetaLinksInner } from './ListActivities200ResponseMetaLinksInner';
import {
    ListActivities200ResponseMetaLinksInnerFromJSON,
    ListActivities200ResponseMetaLinksInnerFromJSONTyped,
    ListActivities200ResponseMetaLinksInnerToJSON,
    ListActivities200ResponseMetaLinksInnerToJSONTyped,
} from './ListActivities200ResponseMetaLinksInner';

/**
 * 
 * @export
 * @interface ListForumThreads200ResponseMeta
 */
export interface ListForumThreads200ResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseMeta
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseMeta
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseMeta
     */
    lastPage?: number;
    /**
     * 
     * @type {Array<ListActivities200ResponseMetaLinksInner>}
     * @memberof ListForumThreads200ResponseMeta
     */
    links?: Array<ListActivities200ResponseMetaLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseMeta
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseMeta
     */
    perPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseMeta
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof ListForumThreads200ResponseMeta
     */
    total?: number;
}

/**
 * Check if a given object implements the ListForumThreads200ResponseMeta interface.
 */
export function instanceOfListForumThreads200ResponseMeta(value: object): value is ListForumThreads200ResponseMeta {
    return true;
}

export function ListForumThreads200ResponseMetaFromJSON(json: any): ListForumThreads200ResponseMeta {
    return ListForumThreads200ResponseMetaFromJSONTyped(json, false);
}

export function ListForumThreads200ResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListForumThreads200ResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['current_page'] == null ? undefined : json['current_page'],
        'from': json['from'] == null ? undefined : json['from'],
        'lastPage': json['last_page'] == null ? undefined : json['last_page'],
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(ListActivities200ResponseMetaLinksInnerFromJSON)),
        'path': json['path'] == null ? undefined : json['path'],
        'perPage': json['per_page'] == null ? undefined : json['per_page'],
        'to': json['to'] == null ? undefined : json['to'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function ListForumThreads200ResponseMetaToJSON(json: any): ListForumThreads200ResponseMeta {
    return ListForumThreads200ResponseMetaToJSONTyped(json, false);
}

export function ListForumThreads200ResponseMetaToJSONTyped(value?: ListForumThreads200ResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current_page': value['currentPage'],
        'from': value['from'],
        'last_page': value['lastPage'],
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(ListActivities200ResponseMetaLinksInnerToJSON)),
        'path': value['path'],
        'per_page': value['perPage'],
        'to': value['to'],
        'total': value['total'],
    };
}

